module.exports = __webpack_public_path__ + "img/Ha.2a7aec48.png";